import { IGlobalPeriodContext, useGlobalPeriod } from "../../context";
import moment from "moment";
import { PortfolioApi } from "@iliotech/generated-api-v3";
import { useQuery } from "react-query";
import { API_BASE } from "../../../constants/constants";

export const useAllocationHistory = (
  portfolioId: string,
  periodContext?: IGlobalPeriodContext
) => {
  const { period } = periodContext || useGlobalPeriod();
  const from = !!period?.from
    ? moment(period.from).format("YYYY-MM-DD")
    : undefined;
  const to = !!period?.to ? moment(period.to).format("YYYY-MM-DD") : undefined;
  const api = new PortfolioApi(undefined, `${API_BASE}/api`);
  return useQuery(
    [`portfolio-allocation-history`, { portfolioId, from, to }],
    () => api.getPortfolioAllocationHistory(portfolioId, from, to)
  );
};
